import { render, staticRenderFns } from "./DisplayDifference.vue?vue&type=template&id=bd02a924&scoped=true"
import script from "./DisplayDifference.vue?vue&type=script&lang=js"
export * from "./DisplayDifference.vue?vue&type=script&lang=js"
import style0 from "./DisplayDifference.vue?vue&type=style&index=0&id=bd02a924&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd02a924",
  null
  
)

export default component.exports